import script from "./PatientEngagementSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientEngagementSection.vue?vue&type=script&setup=true&lang=js"

import "./PatientEngagementSection.vue?vue&type=style&index=0&id=17674d36&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17674d36"]])

export default __exports__